import React from 'react';
import {
  Dialog,
  DialogBackdrop,
  DialogContent,
  DialogFooter,
  PrimaryButton,
  TertiaryButton,
} from '@tricor-digital-team/vistra-design-system';

const CancelStep = ({ dialog, handleExit }) => {
  return (
    <DialogBackdrop id="dialog-backdrop" {...dialog}>
      <Dialog
        id="dialog-container"
        hideOnEsc={false}
        hideOnClickOutside={false}
        {...dialog}
        aria-label="Example Label"
        size={'medium'}
      >
        <DialogContent>
          <div className="text-black text-2xl mb-4 font-medium">Are you sure you want to exit?</div>
          <div className="text-black mt-4 text-base">
            This action will not save your details from this application and cannot be undone.
          </div>
        </DialogContent>
        <DialogFooter>
          <div className="flex justify-between items-center w-full py-3">
            <TertiaryButton label="Exit" onClick={handleExit} size="large" />
            <PrimaryButton label="Go back" onClick={() => dialog.hide()} size="large" />
          </div>
        </DialogFooter>
      </Dialog>
    </DialogBackdrop>
  );
};
export default CancelStep;
